import {Validators} from '@angular/forms';

import {ComponentTypesEnum} from '../../app/shared/enums';
import {BaseControl, SelectControl} from '../../app/shared/classes';

import {
    ReportTableActionMenuTypesEnum,
    ReportTableActionsEnum,
    ReportTableButtonTypesEnum, ReportTableColumn,
    ReportTableConfigInterface,
    ReportTableData,
    ReportTableDataRow
} from '../../app/shared/components/report-table';

export const PanelLegalDeclarationsFilterControls: BaseControl[] = [
    new SelectControl({
        name: null,
        value: null,
        placeholder: 'Type',
        validators: [],
        componentType: ComponentTypesEnum.Select,
        options: []
    }),
    new SelectControl({
        name: null,
        value: null,
        placeholder: 'Version',
        validators: [],
        componentType: ComponentTypesEnum.Select,
        options: []
    }),
    new SelectControl({
        name: null,
        value: null,
        placeholder: 'Platform',
        validators: [],
        componentType: ComponentTypesEnum.Select,
        options: []
    }),
    new SelectControl({
        name: null,
        value: null,
        placeholder: 'Status',
        validators: [],
        componentType: ComponentTypesEnum.Select,
        options: []
    }),
    new SelectControl({
        name: null,
        value: null,
        placeholder: 'Broker',
        validators: [],
        componentType: ComponentTypesEnum.Select,
        options: []
    }),
    new BaseControl({
        name: null,
        value: null,
        placeholder: 'Effective date',
        validators: [],
        componentType: ComponentTypesEnum.Datepicker
    }),
    new BaseControl({
        name: null,
        value: null,
        placeholder: 'Publish date',
        validators: [],
        componentType: ComponentTypesEnum.Datepicker
    }),
    new BaseControl({
        name: null,
        value: null,
        placeholder: 'Expiration date',
        validators: [],
        componentType: ComponentTypesEnum.Datepicker
    }),
    new BaseControl({
        name: null,
        value: null,
        placeholder: 'Uploaded by',
        validators: [Validators.minLength(3)],
        componentType: ComponentTypesEnum.Text,
    }),
    new BaseControl({
        name: null,
        value: null,
        placeholder: 'Approved by',
        validators: [],
        componentType: ComponentTypesEnum.Text
    }),
    new BaseControl({
        name: null,
        value: null,
        placeholder: 'Validated by',
        validators: [],
        componentType: ComponentTypesEnum.Text
    })
];

export const PanelLegalDeclarationsDataTableItems = (): ReportTableData[] => {
    return [
        new ReportTableData<string>({
            colId: '',
            value: null,
            hidden: false
        }),
        new ReportTableData<string>({
            colId: '',
            value: null,
            hidden: false
        }),
        new ReportTableData<string>({
            colId: '',
            value: null,
            hidden: false
        }),
        new ReportTableData<string>({
            colId: '',
            value: null,
            hidden: false
        }),
        new ReportTableData<string>({
            colId: '',
            value: null,
            hidden: false
        }),
        new ReportTableData<string>({
            colId: '',
            value: null,
            hidden: false
        }),
        new ReportTableData<string>({
            colId: '',
            value: null,
            hidden: false
        }),
        new ReportTableData<string>({
            colId: '',
            value: null,
            hidden: false
        }),
        new ReportTableData<string>({
            colId: '',
            value: null,
            hidden: false
        }),
        new ReportTableData<string>({
            colId: '',
            value: null,
            hidden: false
        }),
        new ReportTableData<string>({
            colId: '',
            value: null,
            hidden: false
        }),
        new ReportTableData<string>({
            colId: '',
            value: null,
            hidden: false
        }),
    ];
};

export const PanelLegalDeclarationsDataTableConfig: ReportTableConfigInterface = {
    rows: [
        new ReportTableDataRow({
            rowId: 1,
            dataItems: [
                new ReportTableData({
                    colId: 'File',
                    value: 'Client Agreement',
                    hidden: false
                }),
                new ReportTableData({
                    colId: 'Type',
                    value: 'Lorem ipsum',
                    hidden: false
                }),
                new ReportTableData({
                    colId: 'Version',
                    value: '1.0',
                    hidden: false
                }),
                new ReportTableData({
                    colId: 'Platform',
                    value: 'Lorem ipsum',
                    hidden: false
                }),
                new ReportTableData({
                    colId: 'Status',
                    value: 'Lorem ipsum',
                    hidden: false
                }),
                new ReportTableData({
                    colId: 'Broker',
                    value: 'Lorem ipsum',
                    hidden: false
                }),
                new ReportTableData({
                    colId: 'Effective day',
                    value: '02/02/2020',
                    hidden: false
                }),
                new ReportTableData({
                    colId: 'Publish date',
                    value: '03/03/2020',
                    hidden: false
                }),
                new ReportTableData({
                    colId: 'Expiration date',
                    value: '09/09/2021',
                    hidden: false
                }),
                new ReportTableData({
                    colId: 'Uploaded by',
                    value: 'Lorem ipsum',
                    hidden: false
                }),
                new ReportTableData({
                    colId: 'Approved by',
                    value: 'Lorem ipsum',
                    hidden: false
                }),
                new ReportTableData({
                    colId: 'Validated by',
                    value: 'Lorem ipsum',
                    hidden: false
                }),
            ]
        })
    ],
    columns: [
        new ReportTableColumn({
            label: 'File',
            selector: ''
        }),
        new ReportTableColumn({
            label: 'Type',
            selector: ''
        }),
        new ReportTableColumn({
            label: 'Version',
            selector: ''
        }),
        new ReportTableColumn({
            label: 'Platform',
            selector: ''
        }),
        new ReportTableColumn({
            label: 'Status',
            selector: ''
        }),
        new ReportTableColumn({
            label: 'Broker',
            selector: ''
        }),
        new ReportTableColumn({
            label: 'Effective date',
            selector: ''
        }),
        new ReportTableColumn({
            label: 'Publish date',
            selector: ''
        }),
        new ReportTableColumn({
            label: 'Expiration date',
            selector: ''
        }),
        new ReportTableColumn({
            label: 'Uploaded by',
            selector: ''
        }),
        new ReportTableColumn({
            label: 'Approved by',
            selector: ''
        }),
        new ReportTableColumn({
            label: 'validated by',
            selector: ''
        }),
    ],
    hiddenColumnIds: [],
    actionMenu: true,
    actionMenuType: ReportTableActionMenuTypesEnum.Buttons,
    actionMenuItems: [
        {
            buttonType: ReportTableButtonTypesEnum.Edit,
            action: ReportTableActionsEnum.Edit
        },
        {
            buttonType: ReportTableButtonTypesEnum.Download,
            action: ReportTableActionsEnum.Download
        },
        {
            buttonType: ReportTableButtonTypesEnum.Preview,
            action: ReportTableActionsEnum.Preview
        }
    ]

};
